export type AppLocale = 'es' | 'en';

const STORAGE_KEY = 'amaru.locale';

export const isAppLocale = (value: unknown): value is AppLocale => value === 'es' || value === 'en';

/** El último idioma conocido, o `null` si no hay, no es válido o el storage no se puede leer. */
export function readStoredLocale(): AppLocale | null {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isAppLocale(stored) ? stored : null;
  } catch {
    return null;
  }
}

/** Guarda el idioma. Si el storage falla (modo privado, cuota, bloqueado) no lanza. */
export function writeStoredLocale(locale: AppLocale): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Sin persistencia el idioma sigue funcionando en la sesión; manda la preferencia del servidor.
  }
}

/** El idioma del navegador limitado a los que hay: `en*` es inglés, cualquier otro, español. */
export function navigatorLocale(): AppLocale {
  const language = typeof navigator === 'undefined' ? '' : navigator.language ?? '';
  return language.toLowerCase().startsWith('en') ? 'en' : 'es';
}

/**
 * El idioma del arranque, antes de que llegue la preferencia del servidor: el último conocido y, si
 * no hay, el del navegador. Así la próxima carga arranca ya en el idioma correcto.
 */
export function initialLocale(): AppLocale {
  return readStoredLocale() ?? navigatorLocale();
}
